"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Pagination, PaginationContent, PaginationItem, PaginationLink } from "@/components/ui/pagination";
export default function TimelessAesthetics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="120887" id="the-private-studio" className="dark bg-background text-foreground relative min-h-[80vh] w-full flex items-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/dark_slate_texture.png')] bg-cover bg-center opacity-10 mix-blend-luminosity"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-background/80"></div>
      </div>

      {}
      <div className="container mx-auto px-6 md:px-12 relative z-10 h-full flex flex-col justify-center">
        
        {}
        <div ref={ref} className={`relative w-full md:w-3/4 lg:w-1/2 p-8 md:p-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="absolute top-0 left-0 w-16 h-16 border-t-[1px] border-l-[1px] border-primary opacity-40"></div>
          
          {}
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b-[1px] border-r-[1px] border-primary opacity-40"></div>

          {}
          <div className="space-y-6">
            <div className="inline-block px-3 py-1 border border-primary/30 text-[10px] uppercase tracking-widest text-primary mb-4 font-default">
              Select Inquiries Only
            </div>
            <h2 className="text-6xl md:text-8xl lg:text-9xl font-default font-medium uppercase tracking-tighter leading-[0.85]">
              <span className="block text-primary/90 drop-shadow-sm">The Private</span>
              <span className="block text-foreground mt-2">Studio</span>
            </h2>
            
            <p className="text-lg md:text-xl text-foreground/70 max-w-md font-default font-light leading-relaxed pl-2 border-l border-primary/20">
              A highly selective incubator for generational ventures. Access is granted through invitation or qualified referral only. Inquire for Studio Access.
            </p>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-6 md:left-12 z-20">
        <Pagination className="justify-start">
          <PaginationContent className="gap-3">
            <PaginationItem>
              <PaginationLink href="#the-private-studio" isActive className="w-2 h-2 rounded-full p-0 bg-primary border-none hover:bg-primary/80 transition-colors" aria-label="Slide 1" />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#the-private-studio" className="w-2 h-2 rounded-full p-0 bg-muted/20 border-none hover:bg-primary/50 transition-colors" aria-label="Slide 2" />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#the-private-studio" className="w-2 h-2 rounded-full p-0 bg-muted/20 border-none hover:bg-primary/50 transition-colors" aria-label="Slide 3" />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>
    </section>;
}